import { render, staticRenderFns } from "./RecordingsList.vue?vue&type=template&id=af55e63a&"
import script from "./RecordingsList.vue?vue&type=script&lang=js&"
export * from "./RecordingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports